import { useMemo } from 'react';
import { Box } from '@mui/material';
import { GridFooterContainer, GridPagination } from '@mui/x-data-grid';
import './FooterTabela.scss';

const formatBRL = n =>
  (Number.isFinite(n) ? n : 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

const parseValor = v => {
  if (v == null) return NaN;
  if (typeof v === 'number') {
    if (Number.isInteger(v) && Math.abs(v) >= 100000) return v / 100;
    return v;
  }

  const raw = String(v).trim();
  if (!raw) return NaN;

  const only = raw.replace(/[^\d,.-]/g, '');
  const hasComma = only.includes(',');
  const hasDot = only.includes('.');

  if (hasComma && hasDot) {
    const n = parseFloat(only.replace(/\./g, '').replace(',', '.'));
    return Number.isFinite(n) ? n : NaN;
  }
  if (hasComma) {
    const n = parseFloat(only.replace(',', '.'));
    return Number.isFinite(n) ? n : NaN;
  }
  if (hasDot) {
    const n = parseFloat(only);
    return Number.isFinite(n) ? n : NaN;
  }
  if (/^-?\d+$/.test(only)) {
    const nInt = parseInt(only, 10);
    return Math.abs(nInt) >= 100000 ? nInt / 100 : nInt;
  }

  const n = parseFloat(only);
  return Number.isFinite(n) ? n : NaN;
};

export default function FooterTabela({ selectedRowsMap = {} }) {
  const selectedIds = Object.keys(selectedRowsMap);
  const count = selectedIds.length;

  const totalSelecionado = useMemo(() => {
    if (!count) return 0;
    let total = 0;

    for (const id in selectedRowsMap) {
      if (Object.prototype.hasOwnProperty.call(selectedRowsMap, id)) {
        const row = selectedRowsMap[id];
        total += Number.isFinite(parseValor(row?.VALOR)) ? parseValor(row?.VALOR) : 0;
      }
    }
    return total;
  }, [selectedRowsMap, count]);

  return (
    <GridFooterContainer className="dg-footer-container">
      <Box className="dg-footer-left">
        <Box className="dg-footer-count">{`Total de títulos selecionados: ${count}`}</Box>
        <Box className="dg-footer-sum">{`Total Selecionado: ${formatBRL(totalSelecionado)}`}</Box>
      </Box>
      <GridPagination />
    </GridFooterContainer>
  );
}
